export enum MERCHANT_TYPE {
  'GENERAL_MERCHANT' = 200,
  'DISTRIBUTOR' = 210,
  'NATIONAL_RETAILER' = 220,
  'ONLINE_RETAILER' = 230
};
